import { Building2Icon, ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

import { Column, Row, Text } from "@/components";
import { Button } from "@/components/ui/button";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { JobTrackerResponse } from "@/types";

export const JobUpdateModalHeader = ({
  isLastJob,
  jobCount,
  onNext,
  onPrevious,
  selectedIndex,
  selectedJob,
}: {
  isLastJob: boolean;
  jobCount: number;
  onNext: () => void;
  onPrevious: () => void;
  selectedIndex: number | null;
  selectedJob: JobTrackerResponse | null;
}) => {
  const render = () => {
    return (
      <>
        <DialogHeader>
          <Row className="items-center justify-between">
            <DialogTitle>Update Job</DialogTitle>
            <Row className="items-center gap-2">
              <Text variant="muted">
                {(selectedIndex ?? 0) + 1} / {jobCount}
              </Text>
              <Row className="items-center gap-1">
                <Button
                  className="rounded-full"
                  disabled={selectedIndex === null || selectedIndex === 0}
                  onClick={() => {
                    mixpanelUtils.trackButtonClick(
                      "Previous job",
                      MIXPANEL_SCREENS.JOB_TRACKER,
                    );
                    onPrevious();
                  }}
                  variant="secondary"
                >
                  <ChevronLeftIcon />
                </Button>
                <Button
                  className="rounded-full"
                  disabled={isLastJob}
                  onClick={() => {
                    mixpanelUtils.trackButtonClick(
                      "Next job",
                      MIXPANEL_SCREENS.JOB_TRACKER,
                    );
                    onNext();
                  }}
                  variant="secondary"
                >
                  <ChevronRightIcon />
                </Button>
              </Row>
            </Row>
          </Row>
        </DialogHeader>

        <Row className="items-center justify-between rounded-lg bg-slate-50 p-4">
          <Row className="items-center gap-5">
            <Building2Icon className="h-5 w-5 text-slate-600" />
            <Column>
              <Text className="text-slate-900">{selectedJob?.jobTitle}</Text>
              <Text variant="muted">{selectedJob?.company.name}</Text>
            </Column>
          </Row>
          {selectedJob && (
            <Text
              variant="muted"
              className="rounded-full bg-slate-100 px-3 py-1"
            >
              $
              {selectedJob.outstandingRevenue.toLocaleString(undefined, {
                maximumFractionDigits: 2,
              })}
            </Text>
          )}
        </Row>
      </>
    );
  };

  return render();
};
